/**
 * Safe redirect for post-login/OAuth flows.
 * Only allows same-origin paths to prevent open redirects.
 */
const DEFAULT_REDIRECT = '/dashboard';

/**
 * Returns a safe redirect path. Only allows paths that:
 * - Start with exactly '/' (same-origin)
 * - Do not start with '//' (protocol-relative URL)
 * - Are not absolute URLs (no protocol)
 */
export function getSafeRedirect(redirect: string | null | undefined): string {
  if (redirect == null || typeof redirect !== 'string') {
    return DEFAULT_REDIRECT;
  }
  const trimmed = redirect.trim();
  if (
    trimmed === '' ||
    trimmed.startsWith('//') ||
    /^https?:\/\//i.test(trimmed) ||
    /^javascript:/i.test(trimmed)
  ) {
    return DEFAULT_REDIRECT;
  }
  if (trimmed.startsWith('/')) {
    return trimmed;
  }
  return DEFAULT_REDIRECT;
}
